module.exports = __webpack_public_path__ + "7d53e928b032784448aad6b37205bfbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/en/stingray_classica_tablet.jpg
// module id = 858
// module chunks = 0